class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const line = this.dataset.index;

      // get cart
      const cart = await fetch('/cart.js').then(res => res.json());
      const item = cart.items[line - 1];

      // check if deleting free gift
      if (item?.properties?._gift === 'true') {

        const removedGiftIds = JSON.parse(
          sessionStorage.getItem('removedGiftIds') || '[]'
        );

        const variantId = parseInt(item.variant_id);

        // Avoid duplicates
        if (!removedGiftIds.includes(variantId)) {
          removedGiftIds.push(variantId);
          sessionStorage.setItem(
            'removedGiftIds',
            JSON.stringify(removedGiftIds)
          );
        }

        console.log('[Gift] User manually removed gift:', variantId);

      }

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(line, 0, event, null, null, true);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    this.setupBundleButton();
  }

  setupBundleButton() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('#delete-cart-bundle')) {
        this.handleBundleDelete();
      }
    })
  }

  async handleBundleDelete() {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      if (!cart.items.length) {
        window.location.reload();
        return;
      }

      const updates = {};
      let bundleFound = false;

      // Loop through all cart items
      cart.items.forEach(item => {
        const hasBundleProperty = item.properties && item.properties['bundle-product'];

        // Remove only bundle products
        if (hasBundleProperty) {
          updates[item.key] = 0; // delete this bundle product
          bundleFound = true;
        }
      });

      if (!bundleFound) {
        this.showNoBundleItemsMessage?.();
        return;
      }

      // Call update API only for bundle products (don’t touch others)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      const updatedCart = await response.json();

      // ✅ Update bubble and refresh UI
      this.updateCartBubbleCount?.(updatedCart.item_count);
      this.onCartUpdate?.();

      if (updatedCart.item_count === 0) {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.classList.add('is-empty');

        if (!window.location.href.includes('/cart')) {
          window.refreshCartDrawer();
        }
      }

    } catch (error) {
      console.error('Error removing bundle products:', error);
      this.showErrorMessage?.();
    }
  }

  // ✅ New helper method for cart bubble update
  updateCartBubbleCount(count) {
    const cartBubble = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    const visuallyHidden = document.querySelector('.cart-count-bubble .visually-hidden');
    const bubbleWrapper = document.querySelector('.cart-count-bubble');

    cartBubble?.forEach((each) => {
      each.textContent = count;
    })

    if (visuallyHidden) visuallyHidden.textContent = `${count} items`;
  }

  showNoBundleItemsMessage() {
    alert('No bundle items found in your cart.');
  }

  showErrorMessage() {
    alert('An error occurred while trying to remove bundle items.');
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input?.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          if (typeof window.handleGiftProduct === 'function') {
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cartState) => {
                window.handleGiftProduct(cartState);
              })
              .catch((err) => {
                console.error('Error fetching cart for gift product logic during cart update:', err);
              });
          }

          // adding free patches for vibration

          if (typeof window.handleAutoProduct === 'function') {
            fetch('/cart.js')
            .then(res => res.json())
            .then(cartState => {
              window.handleAutoProduct(cartState);
              this.updateCartBubbleCount?.(cartState.item_count);
            })
            .catch(err => {
              console.error('Error fetching cart for gift product logic:', err);
            });
        }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId, isDelete = false) {
    this.enableLoading(line);

    document.body.classList.add('cart-updating');

    // ==========================================
    // REMOVE PREVIOUS STYLE TAG IF EXISTS
    // ==========================================
    window._cartSpinnerStyle?.remove();

    const styleTag = document.createElement('style');
    styleTag.textContent = `
      body.cart-updating #CartItem-${line} .loading__spinner,
      body.cart-updating #CartDrawer-Item-${line} .loading__spinner {
        display: flex !important;
      }
    `;
    document.head.appendChild(styleTag);
    window._cartSpinnerStyle = styleTag;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.updateCartBubbleCount?.(parsedState.item_count);

          if (window.location.href.includes('/apps/wishlist')) {
            // If Shopify doesn't send sections (happens on app pages like /apps/wishlist)
            if (!parsedState.sections) {
  
              // Update the cart bubble count
              if (typeof this.updateCartBubbleCount === "function") {
                this.updateCartBubbleCount(parsedState.item_count);
              }
  
              // --- Keep cart drawer open & refresh it ---
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                fetch('/?section_id=cart-drawer')
                  .then(res => res.text())
                  .then(html => {
                    const dom = new DOMParser().parseFromString(html, 'text/html');
                    const newDrawer = dom.querySelector('cart-drawer');
   
                    if (newDrawer) {
                      // Replace existing drawer with updated HTML without closing it
                      const cartDrawerEle = cartDrawer.querySelector('#cartDrawer');
                      cartDrawer.innerHTML = newDrawer.innerHTML
                    }
                  })
                  .catch(err => console.error("Drawer refresh error:", err));
              }
  
              this.disableLoading(line);
              return;
            }
          }

          if (isDelete) {
            document.body.classList.remove('cart-updating');
          }

          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container) return; // section not present on this page (e.g. cart-live-region-text) — skip, don't throw
            const elementToReplace = container.querySelector(section.selector) || container;
            const newHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (newHtml != null) elementToReplace.innerHTML = newHtml;
          });

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        // Freebie handlers run once, via the cartUpdate subscriber below (with a freshly
        // fetched cart). Calling them directly here too caused a double invocation: the
        // subscriber's no-op cycle hid the loader while the direct removal was still in
        // flight, so a threshold-down freebie removal looked like a second loading phase.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // The error container isn't present on every layout — guard against null.
        if (errors) errors.textContent = (window.cartStrings && window.cartStrings.error) || '';
      })
      .finally(() => {
        this.disableLoading(line);
        // Per-line loader cleanup: drop the "updating" state + its style tag so the
        // line spinner clears once this item's update has rendered.
        document.body.classList.remove('cart-updating');
        window._cartSpinnerStyle?.remove();
        window._cartSpinnerStyle = null;
        // NOTE: the freebie handlers are intentionally NOT called here. They run once via
        // the cartUpdate subscriber (published above) — serialized, with a fresh cart
        // between each — so gifts add/remove reliably. Calling them here too caused
        // duplicate, parallel runs whose refreshes raced and left a gift half-removed.
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errText = lineItemError.querySelector('.cart-item__error-text');
      if (errText) errText.textContent = message;
    }

    this.lineItemStatusElement?.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return; // not present on every layout — skip rather than throw
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    // [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Sticky checkout button for mobile Device
window.addEventListener('scroll', function() {
  var scrollableDiv = document.querySelector('.cart-items');
  var targetDiv = document.getElementById('cartCheckoutButton');

  if (scrollableDiv && targetDiv) {
    // Get the scroll position and the height of the scrollable div
    var scrollPosition = window.scrollY;
    var scrollableHeight = (scrollableDiv.offsetHeight);
    
    // Example: Add the class when scrolled past 50% of the scrollable height
    if (scrollPosition < (scrollableHeight) || scrollPosition > (scrollableHeight + 500) ) {
      targetDiv.classList.add('sticky-checkout');
    } else {
      targetDiv.classList.remove('sticky-checkout');
    }
  }
});


// Free gift code 
window.refreshCart = function () {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return Promise.resolve();

  const sections = cartItems.getSectionsToRender();
  const sectionIds = sections.map(section => section.section).join(',');
  const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}`;

  return Promise.all([
    fetch('/cart.js').then(res => res.json()),
    fetch(sectionsUrl).then(res => res.json())
  ])
    .then(([cartState, parsedSections]) => {
      const cartEmpty = cartState.item_count === 0;

      sections.forEach(section => {
        const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) ||
          document.getElementById(section.id);

        if (!elementToReplace || !parsedSections[section.section]) return;

        const html = new DOMParser().parseFromString(
          parsedSections[section.section],
          'text/html'
        );

        const inner = html.querySelector(section.selector);
        if (inner) {
          elementToReplace.innerHTML = inner.innerHTML;
        }
      });

      /* ✅ EMPTY CART HANDLING */
      if (cartEmpty) {
        emptyCart(); // your existing function
      }

      /* ✅ RE-RUN CART LOGIC */
      if (typeof window.handleGiftProduct === 'function') {
        window.handleGiftProduct(cartState);
      }

      if (typeof window.handleAutoProduct === 'function') {
        window.handleAutoProduct(cartState);
      }

      // Keep every cart-count bubble (header + sticky nav) in sync after a freebie change.
      window.updateCartCountBubbles?.(cartState.item_count);

      document.body.classList.remove('cart-updating');
      window.setFreebieLoading?.(false);
    })
    .catch(e => {
      console.error('Cart refresh failed', e);
      window.setFreebieLoading?.(false);
    });
};


window.refreshCartDrawer = function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return Promise.resolve();

  const sections = cartDrawer.getSectionsToRender();
  const sectionIds = sections.map((section) => section.id).join(',');

  let cartDrawerEmpty = false
  let cartCount = null;
  return fetch(`${routes.cart_url}?sections=${sectionIds}`)
    .then((res) => res.json())
    .then((parsedState) => {
      sections.forEach((section) => {
        const sectionHTML = parsedState[section.id];
        const htmlDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const cartDrawerItems = htmlDoc.querySelector('cart-drawer')?.getAttribute('data-cart-count');
        if (cartDrawerItems != null) cartCount = cartDrawerItems;
        if (cartDrawerItems && cartDrawerItems == '0' || cartDrawerItems == 0) {
          cartDrawerEmpty = true
        }
      });

      // If cart drawer empty adding is-empty class to cart drawer
      if (cartDrawerEmpty) {
        emptyCart();
      }

      cartDrawer.renderContents({
        id: null, // or use product ID if available
        sections: parsedState
      });

      // Keep every cart-count bubble in sync (header + mobile sticky nav). The nav isn't
      // part of the re-rendered sections, so a freebie add/remove wouldn't update it otherwise.
      if (cartCount != null) window.updateCartCountBubbles?.(cartCount);

      // Re-evaluate the "add the free gift back" strip against the fresh cart.
      window.updateCartDrawerGiftStrips?.();

      window.setFreebieLoading?.(false);
    })
    .catch((e) => {
      console.error('Cart drawer refresh failed', e);
      window.setFreebieLoading?.(false);
    });
};

function emptyCart() {
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  const cartFooter = document.querySelector('.main-cart__wrapper');
  if (cartFooter) cartFooter.classList.add('is-empty');
  if (cartDrawerWrapper) cartDrawerWrapper.classList.add('is-empty');
}


// ==========================================
// FREE GIFT LOGIC
// ==========================================

window.isGiftProductUpdating = false;
window._giftAddInProgress = false;

// Update every cart-count bubble on the page (header + mobile sticky nav) to `count`.
// Used to keep the count in sync after cart changes that happen outside the normal
// add-to-cart flow — e.g. a freebie added/removed by the reward-threshold handlers,
// whose refresh only re-renders the drawer sections, not the sticky nav.
window.updateCartCountBubbles = function (count) {
  const n = parseInt(count, 10);
  if (Number.isNaN(n)) return;
  document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
    el.textContent = n;
  });
  document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((el) => {
    el.textContent = `${n} items`;
  });
};

// Overlay + spinner shown on the cart drawer while a freebie is being added/removed.
// The class lives on the persistent <cart-drawer> element so it survives re-render.
window.setFreebieLoading = function (on) {
  document.querySelector('cart-drawer')?.classList.toggle('is-freebie-loading', !!on);
  document.querySelector('.main-cart__wrapper')?.classList.toggle('is-freebie-loading', !!on);
};

// ==========================================
// CART DRAWER — "add the free gift back" strip
// ==========================================
// Shows a thin strip in the drawer for a free gift that was auto-added and then
// MANUALLY removed (so it won't auto-add again) while its threshold is still met.
// Uses the SAME eligible-total / threshold logic as handleGiftProduct.

window.updateCartDrawerGiftStrips = async function (cartState) {
  const strips = document.querySelectorAll('#CartDrawer .cd-gift-strip');
  if (!strips.length) return;

  let cart = cartState;
  if (!cart || !cart.items) {
    cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .catch(() => null);
  }
  if (!cart || !cart.items) return;

  // Eligible totals, mirroring handleGiftProduct (exclude gifts +
  // Device/Combo). Compute both bases so each strip can use its own subtotal setting.
  let baseSubtotal = cart.original_total_price / 100; // "on subtotal" (before discounts)
  let baseTotal = cart.total_price / 100; // final total
  let cartQuantity = 0;
  cart.items.forEach((item) => {
    const excl =
      item.product_type === 'Device' ||
      item.product_type === 'Combo' ||
      (item.properties && item.properties._gift == 'true');
    if (excl) {
      baseSubtotal -= item.final_line_price / 100;
      baseTotal -= item.final_line_price / 100;
    }
    if (!(item.properties && item.properties._gift == 'true')) {
      cartQuantity += item.quantity;
    }
  });

  const removed = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]');

  let visibleCount = 0;
  strips.forEach((strip) => {
    const variantId = parseInt(strip.getAttribute('data-cd-variant-id'), 10);
    const threshold = parseFloat(strip.getAttribute('data-cd-threshold')) || 0;
    const qtyThreshold = parseInt(strip.getAttribute('data-cd-qty-threshold'), 10) || 0;
    const onSubtotal = strip.getAttribute('data-cd-subtotal') === 'true';
    const totalPrice = onSubtotal ? baseSubtotal : baseTotal;

    let met = false;
    if (qtyThreshold > 0) met = cartQuantity >= qtyThreshold;
    else if (threshold > 0) met = totalPrice >= threshold;

    const inCart = cart.items.some(
      (it) => parseInt(it.variant_id, 10) === variantId && it.properties && it.properties._gift === 'true'
    );
    const wasRemoved = removed.indexOf(variantId) !== -1;

    // Show only after a manual removal, while the threshold is still met and it's not in cart.
    const show = met && !inCart && wasRemoved;
    strip.hidden = !show;
    if (show) visibleCount += 1;
  });

  // Show the floating gift button only when there's at least one eligible strip.
  const wrap = document.getElementById('cart-drawer-gift-fab-wrap');
  const cd = document.querySelector('cart-drawer');
  if (wrap) {
    if (visibleCount > 0) {
      wrap.hidden = false;
      const countEl = wrap.querySelector('.cd-gift-fab__count');
      if (countEl) countEl.textContent = visibleCount;
      const fab = document.getElementById('cart-drawer-gift-fab');
      if (fab) fab.setAttribute('aria-expanded', cd && cd.classList.contains('cd-gift-open') ? 'true' : 'false');
    } else {
      // Nothing to offer — hide the button and collapse the panel.
      wrap.hidden = true;
      if (cd) cd.classList.remove('cd-gift-open');
    }
  }
};

window.addCartDrawerGift = async function (strip) {
  if (!strip || !strip.getAttribute) return;
  const vid = parseInt(strip.getAttribute('data-cd-variant-id'), 10);
  if (!vid) return;

  window.setFreebieLoading?.(true);
  try {
    // Treat it as a normal auto-gift again so it isn't re-hidden / re-removed.
    let removed = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]');
    removed = removed.filter((id) => id !== vid);
    sessionStorage.setItem('removedGiftIds', JSON.stringify(removed));

    // Match the properties the free gift system uses when it auto-adds.
    const properties = { _gift: 'true', _auto: 'true', _d_gift: false, _gift_uid: Date.now().toString() };

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: properties }),
    });
    await new Promise((r) => setTimeout(r, 300));
    await window.refreshCartDrawer?.();
  } catch (e) {
    console.error('[Gift] strip add failed', e);
  } finally {
    window.setFreebieLoading?.(false);
  }
};

// Delegated clicks (survive drawer re-renders).
document.addEventListener('click', function (e) {
  // Strip Add button
  const btn = e.target.closest('.cd-gift-strip__add');
  if (btn) {
    e.preventDefault();
    window.addCartDrawerGift(btn.closest('.cd-gift-strip'));
    return;
  }

  // Floating gift button — toggle the strips panel (state on <cart-drawer> so it
  // persists across re-renders, like the other drawer panels).
  const fab = e.target.closest('#cart-drawer-gift-fab');
  if (fab) {
    e.preventDefault();
    const cd = fab.closest('cart-drawer');
    if (cd) {
      const open = cd.classList.toggle('cd-gift-open');
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return;
  }

  // Click outside an open panel closes it.
  const cdOpen = document.querySelector('cart-drawer.cd-gift-open');
  if (cdOpen && !e.target.closest('#cart-drawer-gift-fab-wrap')) {
    cdOpen.classList.remove('cd-gift-open');
    const openFab = document.getElementById('cart-drawer-gift-fab');
    if (openFab) openFab.setAttribute('aria-expanded', 'false');
  }
});

// ==========================================
// READ CONFIGS FROM DOM
// ==========================================

function readGiftConfigs() {
  // Cart page renders the visible strip (#free-gift-bar); the cart drawer
  // renders a hidden data-only element (#free-gift-data). Either provides config.
  const giftBar = document.getElementById('free-gift-bar') || document.getElementById('free-gift-data');
  if (!giftBar) return [];
  try {
    return JSON.parse(giftBar.dataset.giftConfigs || '[]');
  } catch (e) {
    console.error('[Gift] Failed to parse configs', e);
    return [];
  }

}

// ==========================================
// HANDLE GIFTS
// ==========================================

window.handleGiftProduct = async function (cartState) {

  // Prevent multiple simultaneous calls
  if (window.isGiftProductUpdating) return;
  // Prevent duplicate add/remove operations
  if (window._giftAddInProgress) return;
  window.isGiftProductUpdating = true;

  try {

    // ==========================================
    // VALIDATE CART
    // ==========================================

    if (!cartState || !cartState.items) return;
    const giftConfigs = readGiftConfigs();
    const removedGiftIds = JSON.parse(
      sessionStorage.getItem('removedGiftIds') || '[]'
    );

    if (!giftConfigs.length) return;

    // ==========================================
    // GET FRESH CART (single source of truth)
    // ==========================================

    const freshRes = await fetch('/cart.js');
    const freshCart = await freshRes.json();

    // ==========================================
    // CALCULATE CART VALUES (from freshCart, NOT the passed-in cartState)
    // ==========================================

    let freebieOnSubtotal;
    if (document.getElementById('free-gift-bar')) {
      // Cart page — read from the visible strip's container (unchanged behaviour)
      const freeGiftWrapper = document.querySelector('.free-gift-container');
      freebieOnSubtotal = freeGiftWrapper?.getAttribute('data-freebie-on-subtotal');
    } else {
      // Cart drawer — read from the hidden data element
      freebieOnSubtotal = document.getElementById('free-gift-data')?.getAttribute('data-freebie-on-subtotal');
    }

    let totalPrice = freebieOnSubtotal == 'true' ? freshCart.original_total_price / 100 : freshCart.total_price / 100;

    let cartQuantity = 0;
    freshCart.items.forEach(item => {
      if (item.product_type === 'Device' || item.product_type === 'Combo') {
        totalPrice -= item.final_line_price / 100;
      }

      // Excluding Freebies from cart total value
      if (item.properties?._gift == 'true') {
        totalPrice -= item.final_line_price / 100;
      }

      // Ignore auto-added gifts
      if (item.properties?._gift !== 'true') {
        cartQuantity += item.quantity;
      }

    });

    // ==========================================
    // TRACK IF CART CHANGED
    // ==========================================

    let cartChanged = false;

    // ==========================================
    // LOOP ALL GIFT CONFIGS
    // ==========================================

    for (const config of giftConfigs) {
      const variantId = parseInt(config.variantId);
      const threshold = Number(config.threshold || 0);
      const quantityThreshold = Number(config.quantityThreshold || 0);

      if (!variantId) continue;

      // ==========================================
      // CHECK IF THRESHOLD MET
      // ==========================================

      let thresholdMet = false;
      const wasManuallyRemoved = removedGiftIds.includes(variantId);

      // Quantity based
      if (quantityThreshold > 0) {
        thresholdMet = cartQuantity >= quantityThreshold;
      }
      // Price based
      else if (threshold > 0) {
        thresholdMet = totalPrice >= threshold;
      }

      // ==========================================
      // CHECK IF GIFT EXISTS
      // ==========================================

      // For the ADD decision, only an AUTO-added gift counts as "already present".
      const existingGift = freshCart.items.find(
        item =>
          parseInt(item.variant_id) === variantId &&
          item.properties?._gift === 'true' &&
          item.properties?._auto === 'true'
      );

      // For REMOVAL, match ANY gift line for this variant (don't require _auto), so the
      // gift is reliably removed the moment its threshold drops — in every case.
      const removableGift = freshCart.items.find(
        item =>
          parseInt(item.variant_id) === variantId &&
          item.properties?._gift === 'true'
      );

      // ==========================================
      // ADD GIFT
      // ==========================================

      if (wasManuallyRemoved) {
        const freebieAtc = document.querySelectorAll('.free-gift-addtocart');
        freebieAtc?.forEach((each) => each.classList.remove('hidden'));
      }

      if (thresholdMet && !existingGift && !wasManuallyRemoved) {
        console.log('[Gift] Adding gift:', variantId);
        window._giftAddInProgress = true;
        window.setFreebieLoading(true);

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              _gift: 'true',
              _auto: 'true',
              _d_gift: false,
              _gift_uid: Date.now().toString()
            }
          })
        });

        cartChanged = true;

      }

      // ==========================================
      // REMOVE GIFT
      // ==========================================

      if (!thresholdMet && removableGift) {

        console.log('[Gift] Removing gift:', variantId);

        window._giftAddInProgress = true;
        window.setFreebieLoading(true);

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: removableGift.key,
            quantity: 0
          })
        });

        cartChanged = true;
      }

    }

    // ==========================================
    // REFRESH CART ONLY IF CHANGED
    // ==========================================

    if (cartChanged) {
      console.log('[Gift] Refreshing cart');
      // Brief settle for Shopify cart sync (the add/change POST already returned, so a
      // short wait is enough — keeps the freebie appearing quickly).
      await new Promise(resolve => setTimeout(resolve, 120));

      // Presence-based, not pathname-based: the cart page has <cart-items>, the drawer
      // has <cart-drawer>. Matching on '/cart' broke with trailing slashes / locale
      // prefixes (e.g. /en-gb/cart), which sent the refresh to a no-op path so the
      // freebie never appeared even though it was added.
      if (document.querySelector('cart-items')) {
        await window.refreshCart?.();
      } else {
        await window.refreshCartDrawer?.();
      }
    }

  } catch (e) {
    console.error('[Gift] Error:', e);
  } finally {

    // ==========================================
    // RELEASE LOCKS
    // ==========================================

    setTimeout(() => {
      window._giftAddInProgress = false;
      window.isGiftProductUpdating = false;
    }, 500);

  }

  setTimeout(()=>{
    document.body.classList.remove('cart-updating');
  },1000)

};

// --- End gift logic  ---//



//---adding free product for vibration plate ---//


const TRIGGER_VARIANT_ID = 45019782938821;
const AUTO_VARIANT_ID = 45019838939333;

window.isAutoProductUpdating = false;
window._autoAddInProgress = false;

window.handleAutoProduct = async function (cartState) {
  // Prevent overlapping runs
  if (window.isAutoProductUpdating || window._autoAddInProgress) return;
  if (!cartState?.items?.length) return;

  // Controlled by theme setting:
  // Theme settings > Vibration Plate Free Product > Enable Vibration Plate Free Product
  const enabled = window.enableVibrationFreebie === true;

  // Inspect current cart
  let hasTrigger = false;
  let existingFree = null;

  cartState.items.forEach(item => {
    const variantId = Number(item.variant_id);
    if (variantId === TRIGGER_VARIANT_ID) hasTrigger = true;

    const isVibrationGift =
      variantId === AUTO_VARIANT_ID &&
      item.properties?._gift === 'true' &&
      item.properties?._vibration === 'true';

    if (isVibrationGift) existingFree = item;
  });

  // Decide action:
  // - Add the free product only when the feature is enabled and the trigger is present.
  // - Remove an existing free product when disabled OR the trigger is gone (cleanup).
  const shouldAdd = enabled && hasTrigger && !existingFree;
  const shouldRemove = existingFree && (!enabled || !hasTrigger);

  if (!shouldAdd && !shouldRemove) return;

  window.isAutoProductUpdating = true;
  window.setFreebieLoading(true);

  try {
    if (shouldAdd) {
      window._autoAddInProgress = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: AUTO_VARIANT_ID,
          quantity: 1,
          properties: {
            _gift: 'true',
            _auto: 'true',
            _vibration: 'true',
            _gift_uid: Date.now().toString()
          }
        })
      });
    } else if (shouldRemove) {
      window._autoAddInProgress = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: existingFree.key,
          quantity: 0
        })
      });
    }

    // Small delay for Shopify cart sync, then refresh the UI
    await new Promise(resolve => setTimeout(resolve, 300));

    // Presence-based refresh — see note above (handles /cart, /en-gb/cart, etc.).
    if (document.querySelector('cart-items')) {
      await window.refreshCart?.();
    } else {
      await window.refreshCartDrawer?.();
    }

  } catch (e) {
    console.error('handleAutoProduct error:', e);
  } finally {
    setTimeout(() => {
      window._autoAddInProgress = false;
      window.isAutoProductUpdating = false;
    }, 500);
  }
};

function releaseAutoLock() {
  setTimeout(() => {
    window.isAutoProductUpdating = false;
  }, 400); // 300–500ms is safe
}

window.syncAutoProductWithCart = function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      window.handleAutoProduct(cart);
      window.handleGiftProduct(cart);
    });
};

document.addEventListener('DOMContentLoaded', function () {
  window.syncAutoProductWithCart();
  // Evaluate the drawer "add the free gift back" strip on load. The inline drawer
  // script can't do this (it runs before this deferred file defines the function),
  // which is why a manually-removed gift's strip didn't show after a page refresh.
  window.updateCartDrawerGiftStrips && window.updateCartDrawerGiftStrips();
});

// Hook into cart updates without touching existing handlers (uses the same pub/sub
// that cart.js already publishes on every quantity/line change).
//
// The loader is NOT shown for plain cart changes — only the freebie handlers show it
// (via setFreebieLoading) when they actually add/remove a gift, and their refresh
// hides it again.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // Reuse the fresh cart the event already carries (the add/quantity/remove response)
    // instead of an extra /cart.js round-trip, so the freebie check starts immediately.
    // Fall back to a fetch only if the event didn't include cart data.
    const ready = event && event.cartData && event.cartData.items
      ? Promise.resolve(event.cartData)
      : fetch('/cart.js').then((res) => res.json());
    ready
      .then(async (cart) => {
        // Run the handlers SEQUENTIALLY (not in parallel) and re-read the cart between
        // them, so each handler sees the previous one's add/remove. Running in parallel
        // (or on the same stale cart) made their refreshes race and could leave one gift
        // still showing even though the server removed it — it only caught up on the next
        // cart change. Awaiting each with a fresh cart makes every removal land together.
        const refetch = async (fallback) => {
          try {
            return await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          } catch (e) {
            return fallback;
          }
        };
        await window.handleGiftProduct?.(cart);
        const cart2 = await refetch(cart);
        await window.handleAutoProduct?.(cart2);
      })
      .catch(err => console.error('[Freebie] cartUpdate handling failed:', err))
      .finally(() => {
        // Safety net: if a freebie op showed the loader, its refresh already hid it —
        // this just guarantees it can never get stuck on.
        window.setFreebieLoading?.(false);
        // Re-evaluate the drawer "add the free gift back" strip against the fresh cart.
        window.updateCartDrawerGiftStrips?.();
      });
  });
}